module.exports = __webpack_public_path__ + "img/sheworks.93c000f9.svg";